// Component that displays FAST availible devices.
import React from 'react';

type fastDevices = {
  id: number;
  type: string;
  url: string;
  linkout: string;
}

type fastDevicesProps = {
  fastLogos: fastDevices[];
}

export default function Devices({
  fastLogos,
}: fastDevicesProps) {
  const {
    wp: {
      i18n: {
        __,
      },
    },
  } = window;

  const devicesText = __('Available on your favorite devices:', 'nbc');

  return (
    <div className="fast-devices">
      <div className="fast-devices-text">{devicesText}</div>
      <div className="fast-logos">
        { fastLogos && fastLogos.map((device) => {
          const {
            id,
            type,
            url,
            linkout
          } = device;
          const deviceImgEl = <img src={url} alt={`FAST device ${id}`} />;

          return (
            <div key={id} className={`fast-logo fast-logo__${type}`}>
              { linkout ? 
                <a href={linkout}>{deviceImgEl}</a>
                :
                deviceImgEl
              }
            </div>
          );
        }
        )}
      </div>
    </div>
  );
}
